import { useState } from 'react';
import { useIntl } from 'react-intl';
import * as Styled from './SoloLoginForm.styled';

interface SoloLoginFormProps {
  readonly base: string;
  readonly returnTo?: string;
  readonly sessionTimeoutMinutes: number;
  readonly authFailError?: string;
  readonly wasFormPosted?: boolean;
  readonly postedEmail?: string;
  readonly isAdm?: boolean;
}

export const SoloLoginForm = ({
  base,
  returnTo,
  sessionTimeoutMinutes,
  authFailError,
  wasFormPosted,
  postedEmail,
  isAdm
}: SoloLoginFormProps) => {
  const intl = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);

  const showRememberMe = sessionTimeoutMinutes === 0 || !sessionTimeoutMinutes || sessionTimeoutMinutes >= 10_080;

  return (
    <Styled.FormContainer>
      <Styled.FormHeading>
        {intl.formatMessage({ id: 'pleaseSignIn', defaultMessage: 'Please sign in' })}
      </Styled.FormHeading>

      <form
        action={`https://${base}/user/login`}
        method="post"
        id="register_form"
        autoComplete="off"
        onSubmit={() => setIsSubmitting(true)}
      >
        {authFailError && wasFormPosted && <Styled.ErrorAlert>{authFailError}</Styled.ErrorAlert>}

        <Styled.FieldsList>
          <Styled.FieldItem>
            <Styled.FieldLabel htmlFor="user_email">
              {intl.formatMessage({ id: 'emailAddress', defaultMessage: 'Email address' })}
              {' *'}
            </Styled.FieldLabel>
            <Styled.FieldInput
              type="text"
              name="user_email"
              id="user_email"
              defaultValue={postedEmail ?? ''}
              placeholder={intl.formatMessage({ id: 'myEmailIs', defaultMessage: 'My email is' })}
              required
            />
          </Styled.FieldItem>
          <Styled.FieldItem>
            <Styled.FieldLabel htmlFor="user_password">
              {intl.formatMessage({ id: 'passwordText', defaultMessage: 'Password' })}
              {' *'}
            </Styled.FieldLabel>
            <Styled.FieldInput
              type="password"
              name="user_password"
              id="user_password"
              placeholder={intl.formatMessage({ id: 'passwordText', defaultMessage: 'Password' })}
              required
            />
          </Styled.FieldItem>
        </Styled.FieldsList>

        {showRememberMe && (
          <Styled.RememberMeList>
            <Styled.RememberMeLabel>
              <Styled.RememberMeCheckbox
                type="checkbox"
                name="remember"
                value="1"
                checked={rememberMe}
                onChange={() => setRememberMe((prev) => !prev)}
                id="crowdicityRememberMeCheckbox"
              />
              {intl.formatMessage({ id: 'rememberMe', defaultMessage: 'Remember me' })}
            </Styled.RememberMeLabel>
          </Styled.RememberMeList>
        )}

        {returnTo && <input type="hidden" name="returnTo" value={returnTo} />}

        <Styled.ButtonRow>
          <Styled.ForgotPasswordLink
            href={`/user/${isAdm ? 'admforgotpasswordform' : 'forgotpasswordform'}?returnTo=${returnTo ?? ''}`}
          >
            {intl.formatMessage({ id: 'forgottenPasswordText', defaultMessage: 'Forgotten your password?' })}
          </Styled.ForgotPasswordLink>
          <Styled.SubmitButton type="submit" priority="primary" disabled={isSubmitting} id="popUpForm_submit">
            {intl.formatMessage({ id: 'signIn', defaultMessage: 'Sign in' })}
          </Styled.SubmitButton>
        </Styled.ButtonRow>
      </form>
    </Styled.FormContainer>
  );
};
